import React from 'react';
import RestClient from '../rest/RestClient';
import Entrance from './Entrance';
import CommonHelper from '../helpers/CommonHelper';
import Dropdown from 'react-dropdown';
import { confirmAlert } from 'react-confirm-alert'; // Import
import Config from '../Config';
import Obtainer from '../helpers/Obtainer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Cell from '../ui/Cell';
import Switch from 'react-toggle-switch'
import Table from './units/Table';

export default class Profile extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      roleDescription : '?',
      contactEmail : '?',
      loginOfCurrentAccount : '?',
      accounts: [],
      timeLeft: Entrance.purchaseTimeLeft(),
      timezones:[{value:-1,label:'Undefined'} ],
      timezone:-1,
      tz_idx:0,
      // disabled: false,
      recurring: false,
      uiBusy_forCancelAutopay: false,
      autopayStatus: 'N',
      userInfoLoaded: false,
      mounted: false,
      accountInfoLoaded: 'N',
      switchedSharedDB: false
    };

    this.switchAutoRenew = this.switchAutoRenew.bind(this);
    this.handleCancelAutoPay = this.handleCancelAutoPay.bind(this);

    Obtainer.mixin(Profile);

    this.bindObtain(
      this.OBTAINS().SHARED_DB,
        null,
        (data)=>{
          if(data.usage === 'on'){
            this.setState({switchedSharedDB:true});
          }else if(data.usage === 'off'){
            this.setState({switchedSharedDB:false});
          }
        },
        (error)=>{
        }
    );

    this.bindObtain(
      this.OBTAINS().SWITCH_SHARED_DB,
      null,
      (data)=>{
        if(data.usage === 'on'){
          this.setState({switchedSharedDB:true});
        }else if(data.usage === 'off'){
          this.setState({switchedSharedDB:false});
        }
      },
      (error)=>{
      }
    );

    this.bindObtain(
      this.OBTAINS().USER_TIMEZONE,
      null,
      (data)=>{
        var tzs = [];
        data['tz_list'].forEach(function(tz) {
          var el = {};
          el['value'] = tz;
          el['label'] = tz.replace(/_/g, " ");
            tzs.push(el);
        });
        var tz = data['tz'];
        this.setState({timezones: tzs});
        this.setState({timezone:tz});
        this.selectOptionWithValue(tz);
      },
      (error)=>{

      }
    );

    this.bindObtain(
      this.OBTAINS().USER_INFO,
      null,
      (data)=>{
        this.setState({roleDescription: data['description']});
        this.setState({contactEmail: data['contact_email']});
        //this.setState({timeLeft: data['time_left']});
        this.setState({loginOfCurrentAccount: Entrance.loginOfCurrentAccount()});
        this.setState({accountInfoLoaded:'Y'});
      },
      (error)=>{
      }
    );

    this.bindObtain(
      this.OBTAINS().AUTOPAY_STATUS,
      null,
      (autopayStatus)=>{
        this.setState({autopayStatus:autopayStatus});
      },
      (error)=>{
      }
    );

    this.bindObtain(
      this.OBTAINS().ACCOUNTS,
      null,
      (accounts)=>{
        this.setState({accounts:accounts});
      },
      (error)=>{
      }
    );
  }

  componentWillMount() {
    document.body.classList.add('profile-page');
  }

  componentDidMount() {

    this.setState({mounted:true});

    this.startObtain(this.OBTAINS().USER_TIMEZONE);
    this.startObtain(this.OBTAINS().USER_INFO);
    this.startObtain(this.OBTAINS().AUTOPAY_STATUS);
    this.startObtain(this.OBTAINS().SHARED_DB);
    this.startObtain(this.OBTAINS().ACCOUNTS);

    var refId = setInterval(() => {this.setState({timeLeft: Entrance.purchaseTimeLeft()});}, 10*1000);

    this.setState({refInterval_forTimeleft:refId});
  }


  componentWillUnmount(){
    document.body.classList.remove('profile-page');
    this.cancelObtain(this.OBTAINS().USER_TIMEZONE);
    this.cancelObtain(this.OBTAINS().USER_INFO);
    this.cancelObtain(this.OBTAINS().AUTOPAY_STATUS);
    this.cancelObtain(this.OBTAINS().SHARED_DB);
    this.cancelObtain(this.OBTAINS().ACCOUNTS);

    var id = (this.state.refInterval_forTimeleft);

    if(!CommonHelper.isNull(id)){
      clearInterval(id);
    }

    this.setState({mounted:false});
  }

  toggleSwitch_sharedDb = () => {
     this.setState(prevState => {

       var newSwitchedSharedDB = !prevState.switchedSharedDB;

       this.startObtain(this.OBTAINS().SWITCH_SHARED_DB);

       return {
         switchedSharedDB: newSwitchedSharedDB
       };


     });
   };

  timeleftCountdown(){
    console.log('timeleftCountdown');
    this.setState({timeLeft: Entrance.purchaseTimeLeft()});
    console.log(Entrance.purchaseTimeLeft());
  }

  switchAutoRenew(){
      if (this.state.disabled){
      return;
      }

    var recurring = !this.state.recurring;
    this.setState({recurring:recurring});

  }

  handleCancelAutoPay(){
    //this.props.notie.success('Thing Done!')
      confirmAlert({
          title: 'AutoPay cancellation',

              message: (
                  <div>

                      Are you sure you want to cancel recurring payments?<br/><br/>
                      If you proceed, your subscription will be cancelled.<br/>
                      After expiration you will not be able to run tasks <br/>
                      and get new followers and engagement on your SoundCloud. <br/><br/>
                      Are you sure you want to proceed?

                  </div>
              ), // Message with line breaks
          confirmLabel: 'No, take me back!',
          cancelLabel: 'Yes, cancel.',
          onConfirm: () => null,
          onCancel: () => this.cancelAutoPay(),
      })
  }

  cancelAutoPay(){
    this.setState({uiBusy_forCancelAutopay:true});
    RestClient.cancelAutoPay(
      (data)=>{
        this.setState({autopayStatus: data['autopay']});
        this.setState({uiBusy_forCancelAutopay:false});
      },
      ()=>{
        this.setState({uiBusy_forCancelAutopay:false});

      });
  }

  renderCancelButton(){
    //uiBusy_forCancelAutopay
    return (
      <button disabled={this.state.autopayStatus=='N' || this.state.uiBusy_forCancelAutopay} id='red' type='submit'
      className='button visible'
      style={{display:'inline-block', width:'5em'}}
      onClick={this.handleCancelAutoPay}>Cancel</button>
    );
  }

  selectOptionWithValue(value) {
    var arrayLength = this.state.timezones.length;

    for (var i = 0; i < arrayLength; i++) {
      var option = this.state.timezones[i];
      //console.log(option);
      if (option.value == value) {
        this.setState({tz_idx: i});
        break;
      }
    }
  }

  onSelectTimezone (option) {
    RestClient.setUserTimezone(option.value,
    (data)=>{

    },
    ()=>{
    });
  }

  renderBusySpinner(visible) {
    return (
      <div className="sk-circle" style={{display:(visible?'inline-block':'none')}}>
            <div className="sk-circle1 sk-child"></div>
            <div className="sk-circle2 sk-child"></div>
            <div className="sk-circle3 sk-child"></div>
            <div className="sk-circle4 sk-child"></div>
            <div className="sk-circle5 sk-child"></div>
            <div className="sk-circle6 sk-child"></div>
            <div className="sk-circle7 sk-child"></div>
            <div className="sk-circle8 sk-child"></div>
            <div className="sk-circle9 sk-child"></div>
            <div className="sk-circle10 sk-child"></div>
            <div className="sk-circle11 sk-child"></div>
            <div className="sk-circle12 sk-child"></div>
          </div>);
  }

  renderRow_cancelAutoPay(){
    return(

        <div className="blk-form-row-align-centered">
          <Cell>
          AutoPay is {((this.state.autopayStatus=='Y') ? 'ON':((this.state.autopayStatus=='N') ? 'OFF' : '?'))}.</Cell>
          <Cell style={{ alignItems:'center'}}>
            <div className="blk-form-row-align-centered" style={{ height:'1em'}}>
              <div style={{paddingRight:'0.25em'}}>
              {this.renderBusySpinner(this.state.uiBusy_forCancelAutopay)}</div>
              {this.renderCancelButton()}
            </div>
          </Cell>
        </div>

    );
  }

  render() {
    var spancols = [
      { name: '', span: 1},
      { name: 'Total stats', span: 2},
      { name: 'Daily stats', span: 3},

    ];

  var cols = [
      { key: 'login', label: 'login' },
      { key: 'followed', label: '\u00a0\u00a0followed\u00a0\u00a0' },
      { key: 'unfollowed', label: '\u00a0\u00a0unfollowed\u00a0\u00a0' },
      { key: 'daily_followed', label: '\u00a0\u00a0followed\u00a0\u00a0' },
      { key: 'daily_unfollowed', label: '\u00a0\u00a0unfollowed\u00a0\u00a0' },
      { key: 'total_of_limit', label: '\u00a0\u00a0total/limit\u00a0\u00a0' },

  ];
     return (
      <div className='text-page'>
        <Container>
          <Row>
            <Col>
              <h1>User</h1>
            </Col>
          </Row>
          <Row className='sc-mb-6'>
            <Col>
              Contact email: <span className='span-block-xs sc-text-box profle-page-margin-left'> {this.state.contactEmail} </span>
            </Col>
          </Row>
          <Row className='sc-mb-6'>
            <Col>
              User role: <span className='span-block-xs sc-text-box profle-page-margin-left'> {Entrance.role()} </span>
            </Col>
          </Row>
          <Row className='sc-mb-6'>
            <Col>
              Role description: <span className='span-block-xs profle-page-margin-left'> {this.state.roleDescription} </span>
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col>
              Timezone: <span className='span-block-xs position-relative profle-page-margin-left'><Dropdown baseClassName="TzDropdown sc-dropdown--absolute sc-dropdown" options={this.state.timezones} onChange={this.onSelectTimezone} value={this.state.timezone} placeholder="Select an option" /></span>
            </Col>
          </Row>
          <Row className='sc-mb-6'>
            <Col xs="12" xl="3">
                <button id="green"
                className="sc-btn sc-btn-green sc-btn-middle"
                style={{marginTop: '15px'}} 
                type='submit'
                onClick={() => window.location.replace(Config.dirHostedAt+'/change_pass')}>Change password</button>
            </Col>
            <Col xs="12" lg="4">
                <button disabled={this.state.accountInfoLoaded==='N'} id="red" 
                  className="sc-btn sc-btn-red sc-btn-middle"
                  style={{marginTop: '15px'}}
                  type='submit'
                  onClick={() => window.location.replace(Config.dirHostedAt+'/unlink_account')}>Unlink account</button>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col>
              Use shared DB for all accounts: <span style={{marginLeft: '15px'}}><Switch onClick={this.toggleSwitch_sharedDb} on={this.state.switchedSharedDB}/></span>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col>
                <h1 style={{marginTop: '55px'}}>Current account</h1>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col>
              Login: <i className='profle-page-margin-left'>{this.state.loginOfCurrentAccount}</i>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col>
              Time left: <i className='profle-page-margin-left'>{CommonHelper.convertTimeToFineString(this.state.timeLeft)}</i>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col>
            AutoPay is {((this.state.autopayStatus=='Y') ? 'ON':((this.state.autopayStatus=='N') ? 'OFF' : '?'))}.
            
            <button disabled={this.state.autopayStatus=='N' || this.state.uiBusy_forCancelAutopay} 
                id='red' 
                type='submit'
                style={{marginLeft: '15px'}}
                className='profle-page-margin-left sc-btn sc-btn-red sc-btn-middle'
                onClick={this.handleCancelAutoPay}>Cancel</button>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col>
              <h1 style={{marginTop: '55px'}}>Per account statistics</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table spancols={spancols} cols={cols} data={this.state.accounts} />
            </Col>
          </Row>
        </Container> 
      </div>
    )
  }
}
